import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Subheader } from 'material-ui';
import withTranslation from '../../../hoc/withTranslation';
import style from '../../../styles/styles';
import Info from '../../common/Info/Info';
import { RICHTEXT } from '../../../constants/customfiled';

class AchievementInfo extends React.Component {
    static propTypes = {
        achievement: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        lang: PropTypes.string,
        customFields: PropTypes.arrayOf(PropTypes.object),
    };

    static defaultProps = {
        customFields: [],
        lang: 'fr',
    };

    render() {
        const achievement = this.props.achievement;
        return (
            <Paper>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('generic.information')}
                </Subheader>
                <div style={style.paper}>
                    <Info
                        title={this.props.t('generic.identifier')}
                        content={achievement.id}
                    />
                    {achievement.acquisition_type &&
                        <Info
                            title={this.props.t('module.gamification.acquisition_type')}
                            content={this.props.t('module.gamification.acquisition_types.'
                                + achievement.acquisition_type)}
                        />
                    }
                    {achievement.name &&
                        <Info
                            title={this.props.t('generic.name')}
                            content={achievement.name}
                        />
                    }
                    {achievement.description &&
                        <Info
                            title={this.props.t('generic.description')}
                            content={achievement.description}
                        />
                    }
                    {achievement.required_points &&
                        <Info
                            title={this.props.t('module.gamification.required_points')}
                            content={achievement.required_points}
                        />
                    }
                    {achievement.custom_fields
                        && this.props.customFields
                        && this.props.customFields.length !== 0
                        &&
                        achievement.custom_fields.filter(cf => cf.value !== null).map((cf) => {
                            let customField = this.props.customFields.find(item => item.id
                                === cf.id);
                            let name = cf.id;

                            if (customField) {
                                name = customField.name;
                            }

                            if (cf.tag && cf.tag.length > 0) {
                                name += ' (' + cf.tag + ')';
                            }
                            return (
                                <Info
                                    key={cf.id}
                                    title={name}
                                    content={cf.value}
                                    html={customField.type && customField.type === RICHTEXT}
                                />
                            );

                        })}
                    <Info
                        title={this.props.t('module.gamification.achievement_user_count')}
                        content={achievement.achievement_user_count}
                    />
                </div>
            </Paper>
        );
    }
}

export default withTranslation(AchievementInfo);



// WEBPACK FOOTER //
// src/components/achievement/AchievementInfo/AchievementInfo.js